import { render, staticRenderFns } from "./add-agency.vue?vue&type=template&id=bf817db6&scoped=true&"
import script from "./add-agency.vue?vue&type=script&lang=js&"
export * from "./add-agency.vue?vue&type=script&lang=js&"
import style0 from "./add-agency.vue?vue&type=style&index=0&id=bf817db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf817db6",
  null
  
)

export default component.exports